import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllJobTitles as apiForceDeleteAll } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllJobTitles() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAllJobTitles, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiForceDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["jobTitles"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAllJobTitles, isForceDelete };
}
